export default __webpack_public_path__ + "static/media/lamp1.60a76716.webp";